export default __webpack_public_path__ + "static/media/factory_manager_card.200f484f.jpg";